import { useMemo } from 'react';

import ALink from '~/components/features/custom-link';
import {
  useStoreCategories,
  pickRandomCategories,
  categoryHasSubmenu,
} from '~/hooks/useStoreCategories';

const MAX_CATEGORIES = 11;

// Dropdown "Explora categorías" del sub-nav, alimentado por las categorías
// reales del programa (endpoint v1 vía TanStack Query). Conserva la estructura
// del template Riode (.category-dropdown / .category-menu / .megamenu).
function BrowseCategories() {
  const { data = [], isLoading } = useStoreCategories();

  // 11 categorías aleatorias (memoizadas para no re-barajar en cada render).
  const categories = useMemo(() => pickRandomCategories(data, MAX_CATEGORIES), [data]);

  return (
    <div className="dropdown category-dropdown" data-visible="true">
      <ALink href="#" className="category-toggle" title="Explora categorías">
        <i className="d-icon-bars"></i>
        <span>Explora categorías</span>
      </ALink>

      <div className="dropdown-box">
        <ul className="menu vertical-menu category-menu">
          {isLoading && (
            <li>
              <ALink href="#">Cargando...</ALink>
            </li>
          )}

          {!isLoading && categories.length === 0 && (
            <li>
              <ALink href="#">Sin categorías</ALink>
            </li>
          )}

          {categories.map((category) => {
            const hasSubmenu = categoryHasSubmenu(category);
            // ~8 subcategorías por columna, máx 4 columnas (crece horizontal).
            const columns = Math.min(Math.ceil(category.children.length / 8), 4);

            return (
              <li key={category.id} className={hasSubmenu ? 'submenu' : ''}>
                <ALink
                  href={{ pathname: '/shop', query: { category: category.id } }}
                  scroll={false}
                >
                  {category.icon && <i className={category.icon}></i>}
                  {category.name}
                </ALink>

                {hasSubmenu && (
                  // Mismo submodal (megamenu); subcategorías en columnas para
                  // crecer en horizontal en vez de hacia abajo (como el original).
                  <ul className="megamenu" style={{ width: `${columns * 18}rem` }}>
                    <li>
                      <h4 className="menu-title">{category.name}</h4>
                      <hr className="divider" />
                      <ul className="subcategory-columns" style={{ columnCount: columns }}>
                        {category.children.map((subcategory) => (
                          <li key={subcategory.id}>
                            <ALink
                              href={{
                                pathname: '/shop',
                                query: { subcategory: subcategory.id },
                              }}
                              scroll={false}
                            >
                              {subcategory.name}
                            </ALink>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                )}
              </li>
            );
          })}

          {categories.length > 0 && (
            <li>
              <ALink
                href="/shop"
                className="font-weight-semi-bold text-primary text-uppercase ls-25"
              >
                Ver todas
                <i className="d-icon-angle-right"></i>
              </ALink>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default BrowseCategories;
